/**
 * Centralized configuration file for environment variables
 * Import from this file instead of using import.meta.env directly
 *
 * For resolution scaling utilities, see utils/ScaleManager.ts and README.md
 */

// API Configuration
export const API_DEV_BASE_URL = import.meta.env.VITE_DEV_BASE_URL;
export const API_BASE_URL = import.meta.env.VITE_BASE_URL;
export const SIGNALR_BASE_URL = import.meta.env.VITE_SIGNALR_BASE_URL;
export const SIGNALR_BASE_PORT = import.meta.env.VITE_SIGNALR_BASE_PORT;

// Localization Configuration
export const DEFAULT_LOCALE = import.meta.env.VITE_DEFAULT_LOCALE;
export const FALLBACK_LOCALE = import.meta.env.VITE_FALLBACK_LOCALE;

// Debug & Development Configuration
export const DEBUG = import.meta.env.VITE_DEBUG === "true";
export const SIMULATION = import.meta.env.VITE_SIMULATION === "true";
export const EXHIBITION = import.meta.env.VITE_EXHIBITION === "true";

// Resolution Configuration
export const APP_WIDTH = parseInt(import.meta.env.VITE_APP_WIDTH || "1280", 10);
export const APP_HEIGHT = parseInt(
  import.meta.env.VITE_APP_HEIGHT || "1280",
  10,
);

// Logging Configuration
export const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL;
export const LOG_TO_CONSOLE = import.meta.env.VITE_LOG_TO_CONSOLE === "true";

// Type-safe check for development mode
export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;

// Optionally export a config object for easier importing
export default {
  api: {
    devBaseUrl: API_DEV_BASE_URL,
    baseUrl: API_BASE_URL,
    signalRBaseUrl: SIGNALR_BASE_URL,
    signalRBasePort: SIGNALR_BASE_PORT,
  },
  locale: {
    default: DEFAULT_LOCALE,
    fallback: FALLBACK_LOCALE,
  },
  debug: DEBUG,
  simulation: SIMULATION,
  exhibition: EXHIBITION,
  resolution: {
    width: APP_WIDTH,
    height: APP_HEIGHT,
  },
  logLevel: LOG_LEVEL,
  isDevelopment,
  isProduction,
} as const;
